var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIconsmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M10 20c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1zM20 10c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M5 10c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M13.5 6.5c-.4-.4-.4-1 0-1.4L15.6 3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-2.1 2.1c-.3.4-1 .4-1.4 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M2.9 17.1c-.4-.4-.4-1 0-1.4L5 13.6c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-2.1 2.1c-.3.4-1 .4-1.4 0zM17.1 17.1c-.4.4-1 .4-1.4 0L13.6 15c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.1 2.1c.4.3.4 1 0 1.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M6.5 6.5c-.4.4-1 .4-1.4 0L2.9 4.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L6.4 5c.5.4.5 1.1.1 1.5z"
  })));
}
export default SvgLoadingIconsmall;